<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-form @submit.prevent="login">
          <form-account
            :edit="edit"
            :data-form="companyDetail"
          />
          <form-company
            :edit="edit"
            :data-form="companyDetail"
          />
          <!-- submit button -->
          <div
            v-if="companyDetail.status===2"
            class="d-flex justify-content-between container-button"
          >
            <div />
            <div>
              <b-button
                variant="outline-secondary"
                class="ml-1"
                @click="goPage('account-partner')"
              >
                <span class="align-middle">Back</span>
                <feather-icon
                  icon="XCircleIcon"
                  class="ml-50"
                />
              </b-button>
            </div>
          </div>
          <popup v-if="companyDetail.status===1" />
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BCard, BForm, BButton,
} from 'bootstrap-vue'
import FormCompany from '@/views/page/account/form/Company.vue'
import FormAccount from '@/views/page/account/form/Account.vue'
import Popup from '@/views/component/Popup.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    Popup,
    FormCompany,
    FormAccount,
    BButton,
  },
  data() {
    return {
      edit: false,
    }
  },
  computed: {
    ...mapGetters('account', {
      dataClientItem: 'getClientItem',
      companyDetail: 'getCompanyDetail',
      clientId: 'getClientId',
    }),
  },
  mounted() {
    this.setClientId(this.$route.params.id)
    // eslint-disable-next-line radix
    this.getDetail(parseInt(this.clientId))
  },
  methods: {
    ...mapMutations('account', {
      setDetail: 'SET_COMPANY_DETAIL',
      setClientId: 'SET_CLIENT_ID',
    }),
    getDetail(id) {
      const companies = this.dataClientItem.data
      const dataComp = companies.find(item => item.client_id === id)
      this.setDetail(dataComp)
    },
    goPage(url) {
      this.$router.push({ name: url })
    },
  },
}
</script>
